import React from 'react';
import { Globe } from 'lucide-react';
import { languages } from '../locales';

const LanguageDropdown = ({
    language,
    setLanguage,
    showLanguageDropdown,
    setShowLanguageDropdown
}) => {
    const selectLanguage = (langCode) => {
        setLanguage(langCode);
        setShowLanguageDropdown(false);
    };

    const toggleLanguageDropdown = () => {
        setShowLanguageDropdown(!showLanguageDropdown);
    };

    return (
        <div className="relative language-dropdown">
            <button
                onClick={toggleLanguageDropdown}
                aria-label="Change language"
                className="grid h-[38px] w-[38px] place-items-center rounded-full border border-spy-border2 bg-transparent text-spy-soft hover:border-spy-primary hover:text-spy-primary"
            >
                <Globe className="h-[18px] w-[18px]" />
            </button>

            {showLanguageDropdown && (
                <div className="absolute left-0 top-12 z-50 min-w-[150px] rounded-spy border border-spy-border2 bg-spy-surface py-2 shadow-xl">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => selectLanguage(lang.code)}
                            className={`flex w-full items-center space-x-3 px-4 py-2 text-left text-sm hover:bg-spy-bg2 ${language === lang.code ? 'text-spy-primary' : 'text-spy-soft'
                                }`}
                        >
                            <span className="text-lg">{lang.flag}</span>
                            <span className="text-sm font-medium">{lang.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageDropdown;
